import React from "react";
import classes from "./heroCard.module.css";

const Card = ({ img, title, desc }) => {
  return (
    <div className={classes.cardContainer}>
      <div className={classes.cardImg}>
        <img src={img} alt="img" />
      </div>
      <div className={classes.cardDesc}>
        <h1>{title}</h1>
        <h3>{desc}</h3>
        <button className={classes.btn}>Shop now</button>
      </div>
    </div>
  );
};

export default Card;
